webpackJsonp([0],{

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("xFsn");


/***/ }),

/***/ "xFsn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("j9g7");

__webpack_require__("7t+N");

__webpack_require__("gqkz");

var $ = __webpack_require__("7t+N");

// Your JavaScript goes here

// Load your vendor libraries. When you do so, make sure you
// Change the 'vendor' entry in `gulp/webpack/webpack.entry.js`
// Remove CommonChunksPlugin in `gulp/webpack/webpack.prod.js` if you don't have any vendor files
$(document).ready(function () {
  var menuTrigger = document.querySelectorAll('.pl-js-toggle-nav');
  var canvasOverlay = document.querySelector('#site-canvas-overlay');
  var siteWrapper = document.querySelector('#site-wrapper');

  for (var i = 0; i < menuTrigger.length; i += 1) {
    menuTrigger[i].addEventListener('click', toggleNav);
  }
  canvasOverlay.addEventListener('click', toggleNav);

  function toggleNav() {
    siteWrapper.classList.toggle('show-nav');
  }

  $('.gallery-fade').slick({
    dots: false,
    infinite: true,
    speed: 300,
    fade: true,
    cssEase: 'linear'
  });

  $('.tabs-menu a').click(function (event) {
    event.preventDefault();
    $(this).addClass('is-active');
    $(this).siblings().removeClass('is-active');
    var tab = $(this).attr('href');
    $('.tab-content').not(tab).css('display', 'none');
    $(tab).fadeIn();
    $('.gallery-fade').slick('setPosition');
  });
});

// Enables HMR for development purposes. Degrades gracefully to nothing in production
// Must be located directly at the end of this file. Cannot be abstracted into another
// file, or it won't work.
if (false) {
  if (module.hot) module.hot.accept()

  // Silence HMR rubbish logs
  ;(function (global) {
    var consoleLog = global.console.log;
    global.console.log = function () {
      if (!(arguments.length === 1 && typeof arguments[0] === 'string' && arguments[0].match(/^\[(HMR|WDS)\]/))) {
        consoleLog.apply(global.console, arguments);
      }
    };
  })(window);
}

/***/ })

},[1]);


// WEBPACK FOOTER //
// main.js